<template>
  <div class="page-main"  >
    <audio ref="audio">
      <source src="@/assets/audio/fgg1.wav" type="audio/ogg" />
    </audio>
    <div class="page-one" @click="tclick">
        <Item_one @doSth="sayHello"/>
    </div>
    <div class="page-two">
        <Item_two/>
    </div>
  </div>
</template>
<script setup>
import Item_one from '@/components/mobilephone/item_one'
import Item_two from '@/components/computer/item_two'

import { useStore } from "vuex";
import { ref ,onMounted ,onBeforeUnmount } from 'vue'
const audio = ref();
const plays = () => {
  
  if (audio.value) {
    audio.value.play();
  }
};
const tclick =()=>{
  plays()
}
const store = useStore(); 
const sayHello = () => {
  
}
onMounted(() => {
  
    // plays()
})

onBeforeUnmount(() =>{
})
</script>
<style scoped>
.page-main{
  width:100%;
  height:100%;
 /* background-color: rgba(0, 0, 0, 0.1); */
}

@media (min-width:900px) {
  .page-one{
    display: none;
  }
  .page-two{
    display: block;
  }
}
@media only screen and (max-width: 900px) {
  .page-one{
    width: 100%;
    height: 100%;
    background: #080e38;
  }
  .page-two{
    display: none;
  }
}
</style>